/* DR. BALİ — ONE GESTURE, ONE STEP
   For the pinned stories (Arşiv and the homepage Bakım ritüeli): a wheel
   notch, a trackpad flick, a swipe or an arrow key moves exactly one scene
   and waits for it to settle. Trackpad momentum is absorbed, so a flick never
   skips two. Above the first and below the last scene the page scrolls as usual.
   Bakım ritüeli: only the way down is stepped; scrolling up is free, so a
   visitor can always leave upwards without rewinding every step.
   Reduced motion: nothing here runs. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---------- the stories ---------- */
  function archive() {
    var arc = document.querySelector('[data-dm-arc].dm-arc--live');
    if (!arc) return null;
    var track = arc.querySelector('[data-arc-track]');
    var theatre = arc.querySelector('[data-arc-theatre]');
    var n = arc.querySelectorAll('[data-arc-layer]').length;
    if (!track || !theatre || n < 2) return null;
    function geo() {
      var segVh = parseFloat(getComputedStyle(arc).getPropertyValue('--arc-seg')) || 120;
      var vh = theatre.getBoundingClientRect().height || window.innerHeight;
      return { top: track.getBoundingClientRect().top + window.pageYOffset, seg: vh * segVh / 100 };
    }
    return {
      count: n,
      f: function () { var g = geo(); return (window.pageYOffset - g.top) / g.seg; },
      y: function (i) { var g = geo(); return g.top + i * g.seg; },
      inside: function (f) { return f > -0.4 && f < n - 1 + 0.02; },
      ms: 1150
    };
  }

  function ritual(root) {
    var track = root.querySelector('.dm-rj__track');
    var n = root.querySelectorAll('[data-rj-frame]').length;
    if (!track || n < 2) return null;
    function geo() {
      var top = parseFloat(root.style.getPropertyValue('--rj-top')) || 0;
      var r = track.getBoundingClientRect();
      return { top: top, r: r, span: Math.max(1, r.height - (window.innerHeight - top)) };
    }
    return {
      count: n,
      /* frame i sits at f = i (the middle of its stretch of scroll) */
      f: function () { var g = geo(); return ((g.top - g.r.top) / g.span) * n - 0.5; },
      y: function (i) { var g = geo(); return window.pageYOffset + g.r.top - g.top + g.span * ((i + 0.5) / n); },
      inside: function (f) { return root.getAttribute('data-mode') === 'sticky' && f > -0.55 && f < n - 1 + 0.02; },
      upFree: true,
      ms: 950
    };
  }

  function stories() {
    var list = [];
    var a = archive();
    if (a) list.push(a);
    Array.prototype.forEach.call(document.querySelectorAll('[data-dm-rj]'), function (r) { var s = ritual(r); if (s) list.push(s); });
    return list;
  }

  function active() {
    var list = stories();
    for (var i = 0; i < list.length; i++) { var f = list[i].f(); if (list[i].inside(f)) return { s: list[i], f: f }; }
    return null;
  }

  /* ---------- moving ---------- */
  var busy = false, tween = 0, stepEnd = 0;
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  /* going up through a story that lets you: stop any step in progress and let the page scroll */
  function free(A, dir) {
    if (!(dir < 0 && A.s.upFree)) return false;
    if (busy) { cancelAnimationFrame(tween); busy = false; stepEnd = Date.now(); }
    return true;
  }
  function edge(A, dir) { return (dir < 0 && A.f <= 0.02) || (dir > 0 && A.f >= A.s.count - 1 - 0.02); }

  function step(A, dir) {
    var from = Math.max(0, Math.min(A.s.count - 1, dir > 0 ? Math.floor(A.f + 0.02) : Math.ceil(A.f - 0.02)));
    var to = Math.max(0, Math.min(A.s.count - 1, from + dir));
    var y0 = window.pageYOffset, y1 = Math.round(A.s.y(to)), t0 = 0;
    if (Math.abs(y1 - y0) < 2) return;
    busy = true;
    cancelAnimationFrame(tween);
    function frame(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / A.s.ms);
      window.scrollTo(0, y0 + (y1 - y0) * ease(k));
      if (k < 1) tween = requestAnimationFrame(frame);
      else { stepEnd = Date.now(); setTimeout(function () { busy = false; }, 140); }
    }
    tween = requestAnimationFrame(frame);
  }

  /* ---------- wheel and trackpad ---------- */
  var lastT = 0, lastAbs = 0;
  window.addEventListener('wheel', function (e) {
    if (e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    var A = active();
    if (!A) return;
    var dir = e.deltaY > 0 ? 1 : -1;
    if (free(A, dir)) { lastT = Date.now(); lastAbs = 0; return; }
    var abs = Math.abs(e.deltaY) * (e.deltaMode === 1 ? 33 : 1);
    var now = Date.now();
    /* a new gesture: after a pause, or a fresh push stronger than the fading momentum */
    var gap = now - lastT;
    /* momentum only ever fades; a new push is either after a real pause or stronger than the tail */
    var fresh = (gap > 900 || (gap > 300 && abs >= lastAbs * 0.95) || (abs > lastAbs * 2 && abs > 40)) && now - stepEnd > 450;
    lastT = now; lastAbs = abs;
    if (!busy && fresh && edge(A, dir)) return;   /* leave the story: the page scrolls on */
    e.preventDefault();
    if (busy || !fresh || abs < 2) return;
    step(A, dir);
  }, { passive: false });

  /* ---------- touch ---------- */
  var sy = 0, sx = 0, used = false, tracking = false;
  window.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { tracking = false; return; }
    sy = e.touches[0].clientY; sx = e.touches[0].clientX; used = false;
    tracking = !!active();
  }, { passive: true });
  window.addEventListener('touchmove', function (e) {
    if (!tracking || e.touches.length !== 1) return;
    if (e.target.closest && e.target.closest('.dm-at-pop, .dm-rj__facts')) return;
    var dy = sy - e.touches[0].clientY, dx = sx - e.touches[0].clientX;
    if (Math.abs(dx) > Math.abs(dy)) return;
    var A = active();
    if (!A) { tracking = false; return; }
    var dir = dy > 0 ? 1 : -1;
    if (Math.abs(dy) > 6 && free(A, dir)) { tracking = false; return; }
    if (!busy && !used && edge(A, dir) && Math.abs(dy) > 6) { tracking = false; return; }
    e.preventDefault();
    if (!used && !busy && Math.abs(dy) > 26) { used = true; step(A, dir); }
  }, { passive: false });
  window.addEventListener('touchend', function () { tracking = false; }, { passive: true });

  /* ---------- keys ---------- */
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT|BUTTON|A)$/.test(t.tagName))) return;
    var dir = { ArrowDown: 1, PageDown: 1, ' ': e.shiftKey ? -1 : 1, ArrowUp: -1, PageUp: -1 }[e.key];
    if (!dir) return;
    var A = active();
    if (!A || free(A, dir) || (!busy && edge(A, dir))) return;
    e.preventDefault();
    if (!busy) step(A, dir);
  });
})();
